import React from 'react';
import { SERVICES } from '../constants';
import { motion } from 'framer-motion';

const Arsenal: React.FC = () => {
  return (
    <section id="arsenal" className="py-24 bg-brand-black text-brand-white relative">
      <div className="absolute top-0 right-0 p-4 font-mono text-xs text-brand-red/40">
        // SERVICES
      </div>

      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 border-b border-brand-gray pb-8">
          <h2 className="text-6xl md:text-7xl font-sans uppercase">Our Arsenal</h2>
          <p className="font-mono text-brand-red max-w-sm text-right mt-4 md:mt-0 text-sm">
            Full spectrum performance marketing.<br />
            Engineered for enterprise scale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border-t border-l border-brand-gray">
          {SERVICES.map((service, index) => (
            <motion.div 
              key={service.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative border-r border-b border-brand-gray p-10 hover:bg-brand-white hover:text-brand-black transition-all duration-300"
            >
              <div className="flex justify-between items-start mb-6">
                <span className="font-mono text-3xl font-bold opacity-20 group-hover:opacity-100 transition-opacity">
                  {service.id}
                </span>
                <div className="transform group-hover:scale-110 transition-transform duration-300">
                  {service.icon}
                </div>
              </div>
              
              <h3 className="text-3xl md:text-4xl font-sans mb-4 group-hover:text-brand-red transition-colors">
                {service.title}
              </h3>
              
              <p className="font-mono text-sm leading-relaxed opacity-60 group-hover:opacity-100 transition-opacity">
                {service.description}
              </p>

              <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-[10px] font-mono bg-brand-black text-brand-white px-2 py-1 tracking-wider">
                  EXPLORE →
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Arsenal;
